 'use client';

import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import dynamic from 'next/dynamic';

// Widgets fetch their own data; no seeded dashboard metrics.
const CreatorPulse = dynamic(() => import('@/components/dashboard/CreatorPulse').then((m:any) => m.CreatorPulse || m.default || m), { ssr: false, loading: () => <div style={{height:160}} /> });
const DashboardPostStatsSummary = dynamic(
  () => import('@/components/dashboard/DashboardPostStatsSummary').then((m: any) => m.DashboardPostStatsSummary || m.default || m),
  { ssr: false, loading: () => <div style={{ height: 120 }} /> }
);
const ContentCalendar: any = dynamic(
  () => import('@/components/calendar/ContentCalendar').then((m:any) => m.ContentCalendar || m.default || m),
  { ssr: false, loading: () => <div style={{height:220}} /> }
);
const AIContentSuggestions = dynamic(() => import('@/components/dashboard/AIContentSuggestions').then((m:any) => m.AIContentSuggestions || m.default || m), { ssr: false, loading: () => <div style={{height:120}} /> });
const PerformanceForecasting = dynamic(() => import('@/components/dashboard/PerformanceForecasting').then((m:any) => m.PerformanceForecasting || m.default || m), { ssr: false, loading: () => <div style={{height:160}} /> });
const MonetizationIntegrations = dynamic(() => import('@/components/dashboard/MonetizationIntegrations').then((m:any) => m.MonetizationIntegrations || m.default || m), { ssr: false, loading: () => <div style={{height:160}} /> });
const CommunityEngagementHub = dynamic(() => import('@/components/dashboard/CommunityEngagementHub').then((m:any) => m.CommunityEngagementHub || m.default || m), { ssr: false, loading: () => <div style={{height:160}} /> });

export default function DashboardClient() {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Creator Dashboard
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Welcome back! Here's a quick overview of your performance.
        </Typography>
      </Box>

      {/* Client-only CreatorPulse (separate chunk) */}
      <CreatorPulse />

      <DashboardPostStatsSummary />

      <Box sx={{ mt: 4 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          Content Schedule
        </Typography>
        <ContentCalendar showAddEventFab={false} />
      </Box>

      <AIContentSuggestions />

      {/* Client-only PerformanceForecasting (separate chunk) */}
      <PerformanceForecasting />

      <MonetizationIntegrations />

      <CommunityEngagementHub />

    </Container>
  );
}

